export default "__VITE_ASSET__FKEYd1iN__"